/**
 * Emissions Tracker App Entry Point
 *
 * This file is the entry point for the emissions tracker app.
 * The main component is lazily loaded to reduce initial bundle size.
 */

import React from 'react';
import { HydratedRouteInterface } from '../../types/routes';
import { WaitingComponent } from '../../utils/component';
import { rootAppPath, getRootAppPath } from './routes';

// Lazy load the main emissions tracker component
const EmissionsTrackerMain = React.lazy(() =>
  import('./index').then((m) => ({ default: m.EmissionsTrackerRoute }))
);

export const emissionsTrackerRouteEntry: HydratedRouteInterface = {
  id: 'emissions_tracker_entry',
  label: 'Emissions Tracker',
  path: `/${rootAppPath}`,
  exact: false,
  auth: true,
  getRootAppPath,
  component: WaitingComponent(EmissionsTrackerMain),
};
